'use client';

import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function StorySection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center space-x-2 text-accent">
              <Icon name="SparklesIcon" size={24} />
              <span className="text-sm font-semibold uppercase tracking-wide">Our Story</span>
            </div>
            <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary">
              A Vision Born from Experience
            </h2>
            <div className="space-y-4 text-text-secondary leading-relaxed">
              <p>
                Proximus was founded with a clear vision: to transform the business hospitality landscape in Bangalore by offering serviced apartments that truly feel like home while delivering the premium amenities and services of a luxury hotel.
              </p>
              <p>
                Located strategically on Bannerghatta Road, near IIM Bangalore and major corporate hubs, we recognized the need for accommodation that goes beyond traditional hotels—spaces where business travelers can work productively, relax comfortably, and thrive during extended stays.
              </p>
              <p>
                Today, Proximus stands as a trusted name in premium serviced apartments, serving thousands of satisfied guests including corporate professionals, families, and international travelers who seek the perfect blend of comfort, convenience, and quality.
              </p>
            </div>
            <div className="grid grid-cols-3 gap-6 pt-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-accent">2,500+</div>
                <div className="text-sm text-text-secondary mt-1">Happy Guests</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent">4.9/5</div>
                <div className="text-sm text-text-secondary mt-1">Guest Rating</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent">15+</div>
                <div className="text-sm text-text-secondary mt-1">Corporate Partners</div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-premium">
              <AppImage
                src="/assets/images/Reception1-1767660447151.jpg"
                alt="Elegant Proximus reception desk with marble finish and professional staff ready to welcome guests"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-accent text-white p-6 rounded-xl shadow-elevated max-w-xs">
              <Icon name="CheckBadgeIcon" size={32} className="mb-2" />
              <p className="font-semibold">Certified Excellence</p>
              <p className="text-sm text-white/90 mt-1">Committed to the highest standards of hospitality and guest satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}